<template>
  <HoverTooltip position="bottom-end">
    <template #subject>
      <div
        class="text-white bg-orange-300 hover:bg-orange-300 px-7px md:px-2 py-1 rounded-full cursor-pointer ds-text-sm md:ds-text-base"
        data-test-id="favorite-cta"
      >
        <Icon name="eye-slashed" />
      </div>
    </template>
    <template #tooltip>
      <SkippedText />
    </template>
  </HoverTooltip>
</template>

<script>
import { defineComponent } from 'vue'
import { Icon, HoverTooltip } from "@sportsrecruits/playbook";
import SkippedText from "./SkippedText.vue";

export default defineComponent({
  name: "SkippedBadge",
  components: { SkippedText, Icon, HoverTooltip },
})
</script>

<style scoped>
.px-7px {
  padding-left: 7px;
  padding-right: 7px;
}
</style>